.wrapper {
  display: flex;
  flex-direction: column;
  gap: var(--space-2xs);

  min-width: 7rem;
}

.track {
  position: relative;
  overflow: hidden;
  height: 0.375rem;

  background-color: var(--field);

  border-radius: var(--radius-pill);
}

.fill {
  height: 100%;
  width: calc(var(--ratio) * 100%);

  background-color: var(--accent);

  border-radius: inherit;

  transition: width var(--duration-normal) var(--ease);
}

.label {
  font-size: var(--size-100);
  font-variant-numeric: tabular-nums;

  color: var(--text-muted);
}
